// Настройка «брать вес с весов при закрытии мешка», сохраняется в localStorage.
const USE_SCALES_WEIGHT_KEY = 'manualBags.useScalesWeight';

export function getUseScalesWeight(): boolean {
  try {
    return localStorage.getItem(USE_SCALES_WEIGHT_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setUseScalesWeight(enabled: boolean): void {
  try {
    localStorage.setItem(USE_SCALES_WEIGHT_KEY, String(enabled));
  } catch {
    // localStorage недоступен (приватный режим) — настройка просто не сохранится.
  }
}
